var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 311.18 56.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e0e17;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad_copy",
    "data-name": "sad copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.18,8.37l-19,2.61a28.2,28.2,0,1,0,5.88,17.23,27,27,0,0,0-.18-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,8.37,19,11a28.2,28.2,0,1,1-5.88,17.23,27,27,0,0,1,.18-3.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset38);
export default __webpack_public_path__ + "static/media/Asset 38.8d804852.svg";
export { ForwardRef as ReactComponent };